export default __webpack_public_path__ + "static/media/FacilityGroupDisable.17d83f39.svg";